import React from 'react';
import { ACLAuthorizationRequest } from '@/api/bol';
import { LogisticsObjectFormDialog } from '@/components/common/LogisticsObjectFormDialog';
import { defaultActivityTemplate } from '@/utils/activityDefaultTemplate';

export interface ActivityFormDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: { memberIdentifier: string; activityJson: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => Promise<void>;
}

export const ActivityFormDialog: React.FC<ActivityFormDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const handleSubmit = async (data: { memberIdentifier: string; jsonData: string; activityJson?: string; aclAuthorizations?: ACLAuthorizationRequest[] }) => {
    const transformedData = {
      memberIdentifier: data.memberIdentifier,
      activityJson: data.activityJson || data.jsonData,
      aclAuthorizations: data.aclAuthorizations,
    };

    await onSubmit(transformedData);
  };

  return (
    <LogisticsObjectFormDialog
      open={open}
      onClose={onClose}
      onSubmit={handleSubmit}
      title="Create New Activity"
      jsonFieldName="activityJson"
      defaultJsonTemplate={defaultActivityTemplate()}
      jsonLabel="Enter a valid Activity JSON according to the SDL schema:"
      jsonHelperText="The JSON must conform to the Activity schema defined in the BOL API"
      submitButtonText="Create"
    />
  );
};
